import WpstgCloneStaging from './modules/wpstg-clone-staging.js';
import WpstgDirectoryNavigation from './modules/wpstg-directory-navigation.js';
import WpstgTableSelection from './modules/wpstg-table-selection.js';
import WpstgExcludeFilters from './modules/wpstg-exclude-filters.js';
import WpstgResetModal from './modules/wpstg-reset-modal.js';
import WpstgModal from './modules/wpstg-modal.js';
import WpstgCloningAdvanceSettings from './modules/wpstg-cloning-advance-settings.js';
import WpstgMainMenu from './modules/wpstg-main-menu.js';
import WPStagingCommon from './wpstg.js';
import * as dom from './modules/wpstg-dom-utils';
import WpstgProcessModal from './modules/wpstg-process-modal.js';
import WpstgContactUs from './modules/wpstg-contact-us';
import BackupPluginsNotice from './notices/backup-plugins-notice';
import WpstgSidebarMenu from './modules/wpstg-sidebar-menu';

var WPStaging = (function($) {
  const that = {
    isCancelled: false,
    isFinished: false,
    getLogs: false,
    time: 1,
    executionTime: false,
    progressBar: 0,
    cloneExcludeFilters: null,
    directoryNavigator: null,
    tableSelector: null,
    notyf: null,
    areAllTablesChecked: true,
    handleDisplayDependencies: dom.handleDisplayDependencies,
    handleToggleElement: dom.handleToggleElement,
    handleCopyPaste: dom.handleCopyPaste,
    handleCopyToClipboard: dom.handleCopyToClipboard,
    messages: [],
    requestType: '',
    modal: {
      instance: '',
      processTime: 0,
      processInterval: '',
      currentJob: '',
    },
    processModalType: null,

  };
  that.wpstgProcessModal = new WpstgProcessModal();
  const cache = {elements: []};
  let timeout; let ajaxSpinner;

  /**
     * Get / Set Cache for Selector
     * @param {String} selector
     * @return {*}
     */
  cache.get = function(selector) {
    // It is already cached!
    if ($.inArray(selector, cache.elements) !== -1) {
      return cache.elements[selector];
    }

    // Create cache and return
    cache.elements[selector] = jQuery(selector);

    return cache.elements[selector];
  };

  /**
     * Refreshes given cache
     * @param {String} selector
     */
  cache.refresh = function(selector) {
    selector.elements[selector] = jQuery(selector);
  };

  /**
     * Show and Log Error Message
     * @param {String} message
     */
  const showError = function(message) {
    cache.get('#wpstg-try-again').css('display', 'inline-block');
    cache.get('#wpstg-cancel-cloning').text('Reset');
    cache.get('#wpstg-resume-cloning').show();
    cache.get('#wpstg-error-wrapper').show();
    cache.get('#wpstg-error-details').show().html(message);
    cache.get('.wpstg-loading-bar-container').css('visibility', 'hidden');

    cache.get('.wpstg-loader').hide();
    $('.wpstg--modal--process--generic-problem').show().html(message);

    // Error event information for Staging
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      dataType: 'json',
      data: {
        'action': 'wpstg_staging_job_error',
        'accessToken': wpstg.accessToken,
        'nonce': wpstg.nonce,
        'error_message': message,
      },
    });
  };

  /**
   * Show warning during cloning or push process when closing tab or browser, or changing page
   * @param {beforeunload} event
   * @return {null}
   */
  that.warnIfClosingDuringProcess = function(event) {
    // Only some browsers show the message below, most say something like "Changes you made may not be saved" (Chrome) or "You have unsaved changes. Exit?"
    event.returnValue = 'You MUST leave this window open while cloning/pushing. Please wait...';
    return null;
  };

  /**
     *
     * @param response the error object
     * @param prependMessage Overwrite default error message at beginning
     * @param appendMessage Overwrite default error message at end
     * @returns void
     */

  const showAjaxFatalError = function(response, prependMessage, appendMessage) {
    prependMessage = prependMessage ? prependMessage + '<br/><br/>' : 'Something went wrong! <br/><br/>';
    appendMessage = appendMessage ? appendMessage + '<br/><br/>' : '<br/><br/>Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.';

    if (response === false) {
      showError(prependMessage + ' Error: No response.' + appendMessage);
      window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
      return;
    }

    if (typeof response.error !== 'undefined' && response.error) {
      console.error(response.message);
      showError(prependMessage + ' Error: ' + response.message + appendMessage);
      window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
      return;
    }
  };

  /**
     *
     * @param response
     * @return {{ok}|*}
     */
  const handleFetchErrors = function(response) {
    if (!response.ok) {
      showError('Error: ' + response.status + ' - ' + response.statusText + '. Please try again or contact support.');
    }
    return response;
  };

  /** Hide and reset previous thrown visible errors */
  const resetErrors = function() {
    cache.get('#wpstg-error-details').hide().html('');
  };

  /**
     * Common Elements
     */
  const elements = function() {
    const $workFlow = cache.get('#wpstg-workflow');
    let urlSpinner = ajaxurl.replace('/admin-ajax.php', '') + '/images/spinner';
    let timer;

    if (2 < window.devicePixelRatio) {
      urlSpinner += '-2x';
    }

    urlSpinner += '.gif';

    ajaxSpinner = '<img src=\'\'' + urlSpinner + '\' alt=\'\' class=\'ajax-spinner general-spinner\' />';

    const getBaseValues = function() {
      const path = $('#wpstg-use-target-dir').data('base-path');
      const uri = $('#wpstg-use-target-hostname').data('base-uri');
      return {
        path,
      };
    };

    $workFlow
    // Check / Un-check All Database Tables New
        .on('click', '.wpstg-button-unselect', function(e) {
          e.preventDefault();

          if (false === that.areAllTablesChecked) {
            cache.get('#wpstg_select_tables_cloning .wpstg-db-table').prop('selected', 'selected');
            cache.get('.wpstg-button-unselect').text('Unselect All');
            cache.get('.wpstg-db-table-checkboxes').prop('checked', true);
            that.areAllTablesChecked = true;
          } else {
            cache.get('#wpstg_select_tables_cloning .wpstg-db-table').prop('selected', false);
            cache.get('.wpstg-button-unselect').text('Select All');
            cache.get('.wpstg-db-table-checkboxes').prop('checked', false);
            that.areAllTablesChecked = false;
          }
        })

    // Check the max length of the clone name and if the clone name already exists
        .on('keyup', '#wpstg-new-clone-id', function() {
          // Hide previous errors
          document.getElementById('wpstg-error-details').style.display = 'none';

          // This request was already sent, clear it up!
          if ('number' === typeof (timer)) {
            clearInterval(timer);
          }

          // Early bail if site name is empty
          if (this.value === undefined || this.value === '') {
            cache.get('#wpstg-new-clone-id').removeClass('wpstg-error-input');
            cache.get('#wpstg-start-cloning').removeAttr('disabled');
            cache.get('#wpstg-clone-id-error').text('').hide();
            return;
          }

          // Convert the site name to directory name (slugify the site name to create directory name)
          const cloneDirectoryName = WPStagingCommon.slugify(this.value);

          timer = setTimeout(
              function() {
                ajax(
                    {
                      action: 'wpstg_check_clone',
                      accessToken: wpstg.accessToken,
                      nonce: wpstg.nonce,
                      directoryName: cloneDirectoryName,
                    },
                    function(response) {
                      if (!response) {
                        cache.get('#wpstg-new-clone-id').addClass('wpstg-error-input');
                        cache.get('#wpstg-start-cloning').prop('disabled', true);
                        dom.notify('error', 'Error: Please choose correct name for the staging site.');
                        return;
                      }

                      if (response.status === 'success') {
                        cache.get('#wpstg-new-clone-id').removeClass('wpstg-error-input');
                        cache.get('#wpstg-start-cloning').removeAttr('disabled');
                        cache.get('#wpstg-clone-id-error').text('').hide();
                      } else {
                        cache.get('#wpstg-new-clone-id').addClass('wpstg-error-input');
                        cache.get('#wpstg-start-cloning').prop('disabled', true);
                        cache.get('#wpstg-clone-id-error').text(response.message).show();
                      }
                    },
                );
              },
              500,
          );
        })
    // Restart cloning process
        .on('click', '#wpstg-start-cloning', function() {
          resetErrors();
          that.isCancelled = false;
          that.progressBar = 0;
        })
        .on('input', '#wpstg-new-clone-id', function() {
          if ($('#wpstg-clone-directory').length < 1) {
            return;
          }

          const slug = WPStagingCommon.slugify(this.value).substring(0, 16).trim();
          const $targetDir = $('#wpstg-use-target-dir');
          const $targetUri = $('#wpstg-use-target-hostname');
          let path = $targetDir.data('base-path');
          let uri = $targetUri.data('base-uri');

          if (path && slug) {
            path = dom.normalizeAndAppendSlug(path, slug);
          }

          if (uri) {
            uri = uri.replace(/\/+$/g, '') + '/' + slug;
          }


          $('.wpstg-use-target-dir--value').text(path);
          $('.wpstg-use-target-hostname--value').text(uri);

          $targetDir.attr('data-path', path);
          $targetUri.attr('data-uri', uri);
          $('#wpstg_clone_dir').attr('placeholder', path);
          $('#wpstg_clone_hostname').attr('placeholder', uri);
        })
        .on('input', '#wpstg_clone_hostname', function() {
          if ($(this).val() === '' || validateTargetHost()) {
            $('#wpstg_clone_hostname_error').remove();
            return;
          }
          if (!validateTargetHost() && !$('#wpstg_clone_hostname_error').length) {
            $('#wpstg-clone-directory tr:last-of-type').after('<tr><td>&nbsp;</td><td><p id="wpstg_clone_hostname_error" style="color: red;">&nbsp;Invalid host name. Please provide it in a format like http://example.com</p></td></tr>');
          }
        })
    ;

    cloneActions();
  };

  /* @returns {boolean} */
  var validateTargetHost = function() {
    const the_domain = $('#wpstg_clone_hostname').val();

    if (the_domain === '') {
      return true;
    }

    const reg = /^http(s)?:\/\/.*$/;
    if (reg.test(the_domain) === false) {
      return false;
    }
    return true;
  };

  /**
     * Clone actions
     */
  var cloneActions = function() {
    const $workFlow = cache.get('#wpstg-workflow');

    $workFlow
    // Cancel cloning
        .on('click', '#wpstg-cancel-cloning', function() {
          if (!confirm('Are you sure you want to cancel cloning process?')) {
            return false;
          }

          const $this = $(this);

          $('#wpstg-try-again, #wpstg-home-link').hide();
          $this.prop('disabled', true);

          that.isCancelled = true;
          that.progressBar = 0;

          $('#wpstg-processing-status').text('Please wait...this can take up a while.');
          $('.wpstg-loader, #wpstg-show-log-button').hide();

          $this.parent().append(ajaxSpinner);

          cancelCloning();
        })
    // Resume cloning
        .on('click', '#wpstg-resume-cloning', function() {
          resetErrors();
          const $this = $(this);

          $('#wpstg-try-again, #wpstg-home-link').hide();

          that.isCancelled = false;

          $('#wpstg-processing-status').text('Try to resume cloning process...');
          $('#wpstg-error-details').hide();
          $('.wpstg-loader').show();

          $this.parent().append(ajaxSpinner);

          that.startCloning();
        })
    // Cancel update cloning
        .on('click', '#wpstg-cancel-cloning-update', function() {
          resetErrors();

          const $this = $(this);
          $('#wpstg-try-again, #wpstg-home-link').hide();
          $this.prop('disabled', true);

          that.isCancelled = true;

          $('#wpstg-cloning-result').text('Please wait...this can take up a while.');
          $('.wpstg-loader, #wpstg-show-log-button').hide();

          $this.parent().append(ajaxSpinner);

          cancelCloningUpdate();
        })
    // Restart cloning
        .on('click', '#wpstg-restart-cloning', function() {
          resetErrors();

          const $this = $(this);

          $('#wpstg-try-again, #wpstg-home-link').hide();
          $this.prop('disabled', true);

          that.isCancelled = true;

          $('#wpstg-cloning-result').text('Please wait...this can take up a while.');
          $('.wpstg-loader, #wpstg-show-log-button').hide();

          $this.parent().append(ajaxSpinner);

          restart();
        })
    // Delete clone - confirmation
        .on('click', '.wpstg-remove-clone[data-clone]', function(e) {
          dom.setLoadingPlaceholder().then(() => dom.loadingPlaceholder());
          resetErrors();
          e.preventDefault();
          $workFlow.removeClass('active');

          cache.get('.wpstg-loader').show();
          const cloneData = $(this).data('clone');
          const stagingSiteName = $(this).data('name');

          ajax(
              {
                action: 'wpstg_confirm_delete_clone',
                accessToken: wpstg.accessToken,
                nonce: wpstg.nonce,
                clone: $(this).data('clone'),
              },
              function(response) {
                WPStagingCommon.getSwalModal(true, {
                  popup: 'wpstg-swal-popup wpstg-centered-modal wpstg-delete-staging-site-modal',
                  content: 'wpstg--process--content',
                }).fire({
                  title: 'Delete staging site "' + stagingSiteName + '"',
                  icon: 'error',
                  html: response,
                  width: '100%',
                  focusConfirm: false,
                  confirmButtonText: 'Delete',
                  confirmButtonColor: '#e01e5a',
                  showCancelButton: true,
                  onRender: () => {
                    const wpstgUnselectAllTables = document.getElementById('wpstg-unselect-all-tables');
                    const wpstgUnselectAllTablesId = document.getElementById('wpstg-unselect-all-tables-id');

                    if (wpstgUnselectAllTables !== null) {
                      wpstgUnselectAllTables.addEventListener('click', function(e) {
                        if (that.areAllTablesChecked === false) {
                          cache.get('#wpstg_select_tables_cloning .wpstg-db-table').prop('selected', 'selected');
                          cache.get('#wpstgUnselectAllTablesId').text('Unselect All');
                          wpstgUnselectAllTablesId.textContent = 'Unselect All';
                          cache.get('.wpstg-db-table-checkboxes').prop('checked', true);
                          that.areAllTablesChecked = true;
                        } else {
                          cache.get('#wpstg_select_tables_cloning .wpstg-db-table').prop('selected', false);
                          cache.get('#wpstgUnselectAllTablesId').text('Select All');
                          wpstgUnselectAllTablesId.textContent = 'Select All';
                          cache.get('.wpstg-db-table-checkboxes').prop('checked', false);
                          that.areAllTablesChecked = false;
                        }
                      });
                    }

                    const swalContainer = document.querySelector('.wpstg--swal2-html-container');
                    swalContainer.classList.remove('wpstg--swal2-html-container');
                    const _deleteButton = document.querySelector('.wpstg--swal2-confirm');
                    _deleteButton.style.background = '#e01e5a';
                    document.querySelector('.wpstg--swal2-x-mark-line-left').style.background = '#e01e5a';
                    document.querySelector('.wpstg--swal2-x-mark-line-right').style.background = '#e01e5a';
                    document.querySelector('.wpstg--swal2-icon.wpstg--swal2-error').style.borderColor = '#e01e5a';

                    const _btnCancel = WPStagingCommon.getSwalContainer().getElementsByClassName('wpstg--swal2-cancel wpstg--btn--cancel')[0];
                    const btnCancel = _btnCancel.cloneNode(true);
                    _btnCancel.parentNode.replaceChild(btnCancel, _btnCancel);
                    btnCancel.addEventListener('click', function(e) {
                      WPStagingCommon.closeSwalModal();
                      that.modal.instance = null;
                      cache.get('.wpstg-loader').removeClass('wpstg-finished');
                      cache.get('.wpstg-loader').hide();
                      dom.loadingPlaceholder('hidden');
                    });
                  },
                }).then(function(result) {
                  if (result.value) {
                    const deleteDirectory = document.querySelector('#deleteDirectory:checked');
                    let deleteDir = '';
                    const excludedTables = [];
                    if (deleteDirectory !== null) {
                      deleteDir = deleteDirectory.getAttribute('data-deletepath');
                    }
                    $('.wpstg-db-table input:not(:checked)').each(function() {
                      excludedTables.push(this.name);
                    });

                    // WPStagingCommon.closeSwalModal();
                    that.modal.instance = null;
                    const params = {
                      'job': 'delete',
                    };
                    that.wpstgProcessModal.openProcessModal({'action': 'wpstg_delete_clone', 'cloneID': cloneData}, params, false, false);
                    deleteClone(cloneData, deleteDir, excludedTables);
                  }
                });
              },
              'HTML',
          );
        })
    // Delete clone - confirmed
        .on('click', '#wpstg-remove-clone', function(e) {
          resetErrors();
          e.preventDefault();

          cache.get('.wpstg-loader').show();

          deleteClone($(this).data('clone'));
        })
    // Cancel deleting clone
        .on('click', '#wpstg-cancel-removing', function(e) {
          e.preventDefault();
          $('.wpstg-clone').removeClass('active');
          cache.get('#wpstg-removing-clone').html('');
        })
    // Update
        .on('click', '.wpstg-execute-clone', function(e) {
          e.preventDefault();

          const clone = $(this).data('clone');

          that.cloneExcludeFilters = null;
          ajax(
              {
                action: 'wpstg_scanning',
                clone: clone,
                accessToken: wpstg.accessToken,
                nonce: wpstg.nonce,
              },
              function(response) {
                if (response.length < 1) {
                  showError(
                      'Something went wrong! Error: No response.  Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report and contact us.',
                  );
                }

                const jsonResponse = tryParseJson(response);
                if (jsonResponse !== false && jsonResponse.success === false) {
                  showErrorModal(jsonResponse);

                  return;
                }

                $workFlow.html(response);
                // register check disk space function for clone update process.
                checkDiskSpace();
                that.directoryNavigator = new WpstgDirectoryNavigation('#wpstg-directories-listing', wpstg, that.notyf);
                that.directoryNavigator.countSelectedFiles();
                that.tableSelector = new WpstgTableSelection('#wpstg-scanning-db', '#wpstg-workflow', '#wpstg_network_clone', '#wpstg_select_tables_cloning', wpstg, that.notyf);
                that.tableSelector.countSelectedTables();
                that.cloneExcludeFilters = new WpstgExcludeFilters();
                that.switchStep(2);
              },
              'HTML',
          );
        })
        .on('click', '#wpstg-update-cloning-site-button', function(e) {
          window.open(that.data.cloneHostname, '_blank');
        })
    // Reset Clone
        .on('click', '.wpstg-reset-clone', function(e) {
          e.preventDefault();
          const clone = $(this).data('clone');
          const resetModal = new WpstgResetModal(clone);
          resetModal.setNetworkClone($(this).data('network') === 'yes');
          const promise = resetModal.showModal();
          that.areAllTablesChecked = true;

          promise.then((result) => {
            if (result.value) {
              const dirNavigator = resetModal.getDirectoryNavigator();
              const tableSelector = resetModal.getTableSelector();
              const exclFilters = resetModal.getExcludeFilters().getExcludeFilters();

              let includedTables = '';
              let excludedTables = '';
              let selectedTablesWithoutPrefix = '';
              let allTablesExcluded = false;

              if (tableSelector !== null) {
                includedTables = tableSelector.getIncludedTables();
                excludedTables = tableSelector.getExcludedTables();
                selectedTablesWithoutPrefix = tableSelector.getSelectedTablesWithoutPrefix();
              }

              if (includedTables.length > excludedTables.length) {
                includedTables = '';
              } else if (excludedTables.length > includedTables.length) {
                excludedTables = '';
                allTablesExcluded = includedTables === '';
              }

              resetClone(clone, {
                includedTables: includedTables,
                excludedTables: excludedTables,
                allTablesExcluded: allTablesExcluded,
                selectedTablesWithoutPrefix: selectedTablesWithoutPrefix,
                excludeSizeRules: encodeURIComponent(exclFilters.sizes),
                excludeGlobRules: encodeURIComponent(exclFilters.globs),
                excludedDirectories: dirNavigator.getExcludedDirectories(),
                extraDirectories: dirNavigator.getExtraDirectoriesRootOnly(),
              });
            }
          });

          return;
        });
  };

  /**
   * Ajax Requests
   * @param Object data
   * @param Function callback
   * @param string dataType
   * @param bool showErrors
   * @param int tryCount
   * @param float incrementRatio
   */
  var ajax = function(data, callback, dataType, showErrors, tryCount, incrementRatio = null) {
    if ('undefined' === typeof (dataType)) {
      dataType = 'json';
    }

    if (false !== showErrors) {
      showErrors = true;
    }

    tryCount = 'undefined' === typeof (tryCount) ? 0 : tryCount;

    const retryLimit = 5;

    let retryTimeout = 10000 * tryCount;

    incrementRatio = parseInt(incrementRatio);
    if (!isNaN(incrementRatio)) {
      retryTimeout *= incrementRatio;
    }

    const errorMsgFooter = 'Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP STAGING Small Server Settings</a> or submit an error report and contact us. <br/><br/><strong>Tip:</strong> If you get this error while pushing, you can also use the <strong>BACKUP & MIGRATION</strong> feature to move your staging site to live. <a href=\'https://wp-staging.com/docs/how-to-migrate-your-wordpress-site-to-a-new-host/\' target=\'_blank\'>Read more.</a>';

    $.ajax({
      url: ajaxurl + '?action=wpstg_processing&_=' + (Date.now() / 1000),
      type: 'POST',
      dataType: dataType,
      cache: false,
      data: data,
      error: async function(xhr, textStatus, errorThrown) {
        if (WPStaging.requestType === 'wpstg_cloning') {
          const result = await WPStagingCommon.checkMemoryExhaustion(WPStaging.requestType);

          let helpContent = '<br/><br/><button class="wpstg-btn wpstg-primary-btn wpstg-report-issue-button" type="button">CONTACT US</button> for help in solving this issue.';
          if (wpstg.isPro) {
            helpContent = '<br/><br/>Read <a target="_blank" href="' + WPStagingCommon.memoryExhaustArticleLink + '">this article</a> for solving this issue.<br/><br/>Please contact WP Staging support if you need further assistance.';
          }

          if (result !== false) {
            window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
            WPStaging.requestType = '';
            // Refetch staging sites and stop all processing
            cache.get('.wpstg-loader').hide();
            loadOverview();
            WPStagingCommon.showErrorModal(result.message + '.' + helpContent);
            return;
          }
        }

        // try again after 10 seconds
        tryCount++;
        if (tryCount <= retryLimit) {
          console.log('RETRYING ' + tryCount + '/' + retryLimit);
          setTimeout(function() {
            ajax(data, callback, dataType, showErrors, tryCount, incrementRatio);
            return;
          }, retryTimeout);
        } else {
          WPStaging.requestType = '';
          console.log('RETRYING LIMIT');
          const errorCode = 'undefined' === typeof (xhr.status) ? 'Unknown' : xhr.status;
          showError(
              'Fatal Error:  ' + errorCode + ' ' + errorMsgFooter,
          );
        }
      },
      success: function(data) {
        if ('function' === typeof (callback)) {
          callback(data);
        }
      },
      statusCode: {
        404: function() {
          if (tryCount >= retryLimit) {
            showError('Error 404 - Can\'t find ajax request URL! ' + errorMsgFooter);
          }
        },
        500: function() {
          if (tryCount >= retryLimit) {
            showError('Fatal Error 500 - Internal server error while processing the request! ' + errorMsgFooter);
          }
        },
        504: function() {
          if (tryCount > retryLimit) {
            showError('Error 504 - It seems your server is rate limiting ajax requests. Please try to resume after a minute. ' + errorMsgFooter);
          }
        },
        502: function() {
          if (tryCount >= retryLimit) {
            showError('Error 502 - It seems your server is rate limiting ajax requests. Please try to resume after a minute. ' + errorMsgFooter);
          }
        },
        503: function() {
          if (tryCount >= retryLimit) {
            showError('Error 503 - It seem your server is rate limiting ajax requests. Please try to resume after a minute. ' + errorMsgFooter);
          }
        },
        429: function() {
          if (tryCount >= retryLimit) {
            showError('Error 429 - It seems your server is rate limiting ajax requests. Please try to resume after a minute. ' + errorMsgFooter);
          }
        },
        403: function() {
          if (tryCount >= retryLimit) {
            showError('Refresh page or login again! The process should be finished successfully. \n\ ');
          }
        },
        400: function() {
          if (tryCount >= retryLimit) {
            showError('Error 400: ' + '<strong>It looks like you have been logged out.</strong><br/><br/> <a href=\'/wp-login.php\' target=\'_blank\' id="wpstg-login-link">Log in again and try again!</a>');
          }
        },
      },
    });
  };

  /**
   * Next / Previous Step Clicks to Navigate Through Staging Job
   */
  const stepButtons = function() {
    const $workFlow = cache.get('#wpstg-workflow');

    $workFlow
    // Next Button
        .on('click', '.wpstg-next-step-link', function(e) {
          e.preventDefault();

          const $this = $(this);
          const isScan = false;

          if ($('#wpstg_clone_hostname').length && !validateTargetHost()) {
            $('#wpstg_clone_hostname').focus();
            return false;
          }

          if ($this.data('action') === 'wpstg_update' || $this.data('action') === 'wpstg_reset') {
          // Update / Reset Clone - confirmed
            if ($this.data('action') === 'wpstg_update') {
              const selectedSite = $this;
              const selectedSiteWorkFlow = $workFlow;
              const selectedAction = $this.data('action');

              WPStagingCommon.getSwalModal(false, {
                popup: 'wpstg-update-staging-site-modal wpstg-swal-popup wpstg-centered-modal',
                content: 'wpstg--process--content',
              }).fire({
                title: 'Do you want to update the staging site?',
                icon: 'warning',
                html: '<div class="wpstg-confirm-text-line-height wpstg-mt-10px">This will overwrite the staging site with all the selected data from the live site.<br>Use this only if you want to clone the live site again.<br><br> ' +
                    'Unselect all tables and folders that you do not want to overwrite.<br>Do not cancel the update process! This could destroy the staging site.<br>' +
                    'If you are unsure, create a backup of the staging site before proceeding.<br>' +
                    'There is no automatic merging of database data!</div>',
                width: '610px',
                focusConfirm: false,
                confirmButtonText: 'Update',
                showCancelButton: true,
                onRender: () => {
                  const swalContainer = document.querySelector('.wpstg--swal2-html-container');
                  swalContainer.classList.remove('wpstg--swal2-html-container');
                  const _btnCancel = WPStagingCommon.getSwalContainer().getElementsByClassName('wpstg--swal2-cancel wpstg--btn--cancel')[0];
                  const btnCancel = _btnCancel.cloneNode(true);
                  _btnCancel.parentNode.replaceChild(btnCancel, _btnCancel);
                  btnCancel.addEventListener('click', function(e) {
                    WPStagingCommon.closeSwalModal();
                  });
                },
              }).then(function(result) {
                if (result.value) {
                  const selectedSiteDbCheck = document.querySelector('#wpstg-ext-db');
                  if (selectedAction === 'wpstg_cloning') {
                    if (selectedSiteDbCheck.checked) {
                      verifyExternalDatabase(selectedSite, selectedSiteWorkFlow);
                      return;
                    }
                  }
                  WPStagingCommon.closeSwalModal();
                  proceedCloning(selectedSite, selectedSiteWorkFlow);
                }
              });
              return false;
            }
          }
          if ($this.attr('disabled')) {
            return false;
          }

          if ($this.data('action') === 'wpstg_cloning') {
            // Verify External Database If Checked and Not Skipped
            if ($('#wpstg-ext-db').is(':checked')) {
              verifyExternalDatabase($this, $workFlow);
              return;
            }
          }

          proceedCloning($this, $workFlow);
        })
    // Previous Button
        .on('click', '.wpstg-prev-step-link', function(e) {
          e.preventDefault();
          cache.get('.wpstg-loader').hide();
          cache.get('.wpstg-loader').removeClass('wpstg-finished');
          loadOverview();
        });
  };

  /**
   * Get Included (Checked) Database Tables
   * @return {Array}
   */
  const getIncludedTables = function() {
    const includedTables = [];

    $('#wpstg_select_tables_cloning option:selected').each(function() {
      includedTables.push(this.value);
    });

    return includedTables;
  };

  /**
   * Check if clone destination dir is writable
   */
  const isWritableCloneDestinationDir = function() {
    return new Promise(function(resolve) {
      ajax(
          {
            action: 'wpstg_is_writable_clone_destination_dir',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            cloneDir: $('#wpstg_clone_dir').val(),
          },
          function(response) {
            if (response.success) {
              cache.get('.wpstg-loader').hide();
              resolve(true);
            } else {
              showError(
                  'Something went wrong! Error: ' + response.data?.message,
              );
              cache.get('.wpstg-loader').hide();
              document.getElementById('wpstg-error-wrapper').scrollIntoView();
              resolve(false);
            }
          },
          'json',
          false,
      );
    });
  };

  /**
   * Get Excluded (Unchecked) Database Tables
   * Not used anymore!
   * @return {Array}
   */
  const getExcludedTables = function() {
    const excludedTables = [];
    $('.wpstg-db-table input:not(:checked)').each(function() {
      excludedTables.push(this.name);
    });

    return excludedTables;
  };

  /**
   * Verify External Database for Cloning
   */
  var verifyExternalDatabase = function($this, workflow) {
    cache.get('.wpstg-loader').show();
    ajax(
        {
          action: 'wpstg_database_verification',
          accessToken: wpstg.accessToken,
          nonce: wpstg.nonce,
          databaseUser: cache.get('#wpstg-db-user').val(),
          databasePassword: cache.get('#wpstg-db-pass').val(),
          databaseServer: cache.get('#wpstg-db-server').val(),
          databaseDatabase: cache.get('#wpstg-db-database').val(),
          databaseSsl: cache.get('#wpstg-db-ssl').is(':checked'),
        },
        function(response) {
        // Undefined Error
          if (false === response) {
            showError(
                'Something went wrong! Error: No response.' +
            'Please try again. If that does not help, ' +
            '<a href=\'https://wp-staging.com/support/\' target=\'_blank\'>open a support ticket</a> ',
            );
            cache.get('.wpstg-loader').hide();
            return;
          }

          // Throw Error
          if ('undefined' === typeof (response.success)) {
            showError(
                'Something went wrong! Error: Invalid response.' +
            'Please try again. If that does not help, ' +
            '<a href=\'https://wp-staging.com/support/\' target=\'_blank\'>open a support ticket</a> ',
            );
            cache.get('.wpstg-loader').hide();
            return;
          }

          if (response.success) {
            cache.get('.wpstg-loader').hide();
            proceedCloning($this, workflow);
            return;
          }

          if (response.error_type === 'comparison') {
            cache.get('.wpstg-loader').hide();
            let render = '<table class="wpstg-db-comparison-table"><thead><tr><th>Property</th><th>Production DB</th><th>Staging DB</th><th>Status</th></tr></thead><tbody>';
            response.checks.forEach((x) => {
              let icon = '<span class="wpstg-css-tick"></span>';
              if (x.production !== x.staging) {
                icon = '<span class="wpstg-css-cross"></span>';
              }
              render += '<tr><td>' + x.name + '</td><td>' + x.production + '</td><td>' + x.staging + '</td><td>' + icon + '</td></tr>';
            });
            render += '</tbody></table><p>Note: Some MySQL/MariaDB properties do not match. You may proceed but the staging site may not work as expected.</p>';
            WPStagingCommon.getSwalModal(true, {
              popup: 'wpstg-swal-popup wpstg-db-comparison-modal wpstg-centered-modal',
            }).fire({
              title: 'Different Database Properties',
              icon: 'warning',
              html: render,
              width: '650px',
              focusConfirm: false,
              confirmButtonText: 'Proceed',
              showCancelButton: true,
            }).then(function(result) {
              if (result.value) {
                proceedCloning($this, workflow);
              }
            });
            return;
          }

          WPStagingCommon.getSwalModal(true).fire({
            title: 'Different Database Properties',
            icon: 'error',
            html: response.message,
            focusConfirm: true,
            confirmButtonText: 'Ok',
            showCancelButton: false,
          });
          cache.get('.wpstg-loader').hide();
        },
        'json',
        false,
    );
  };

  /**
   * Get Cloning Step Data
   */
  const getCloningData = function() {
    if ('wpstg_cloning' !== that.data.action && 'wpstg_update' !== that.data.action && 'wpstg_reset' !== that.data.action) {
      return;
    }

    that.data.cloneID = new Date().getTime().toString();
    if ('wpstg_update' === that.data.action) {
      that.data.cloneID = $('#wpstg-new-clone-id').data('clone');
    }

    that.data.cloneName = WPStagingCommon.sanitizeEventAttribute($('#wpstg-new-clone-id').val()) || that.data.cloneID;

    if (that.directoryNavigator !== null) {
      that.data.excludedDirectories = encodeURIComponent(that.directoryNavigator.getExcludedDirectories());
      that.data.extraDirectories = encodeURIComponent(that.directoryNavigator.getExtraDirectoriesRootOnly());
    }

    that.data.excludeGlobRules = '';
    that.data.excludeSizeRules = '';
    if (that.cloneExcludeFilters instanceof WpstgExcludeFilters) {
      const rules = that.cloneExcludeFilters.getExcludeFilters();
      that.data.excludeGlobRules = encodeURIComponent(rules.globs);
      that.data.excludeSizeRules = encodeURIComponent(rules.sizes);
    }

    that.data.includedTables = '';
    that.data.excludedTables = '';
    that.data.allTablesExcluded = false;

    if (that.tableSelector !== null) {
      that.data.includedTables = that.tableSelector.getIncludedTables();
      that.data.excludedTables = that.tableSelector.getExcludedTables();
      that.data.selectedTablesWithoutPrefix = that.tableSelector.getSelectedTablesWithoutPrefix();
    }

    if (that.data.includedTables.length > that.data.excludedTables.length) {
      that.data.includedTables = '';
    } else if (that.data.excludedTables.length > that.data.includedTables.length) {
      that.data.excludedTables = '';
      that.data.allTablesExcluded = that.data.includedTables === '';
    }

    if (typeof wpstgPro === 'undefined') {
      return;
    }

    if (typeof wpstgPro.getAdvancedCloningOptions === 'function') {
      that.data = wpstgPro.getAdvancedCloningOptions(that.data);
    }
  };

  var proceedCloning = function($this, workflow) {
    if ($this.data('action') === 'wpstg_cloning') {
      isCloneDestinationPathSameAsRoot().then((result) => {
        if (result && wpstg.isPro) {
          return;
        }

        return isWritableCloneDestinationDir();
      }).then((result) => {
        if (!result) {
          return;
        }

        runCloningSteps($this, workflow);
      }).catch((error) => {
        dom.notify('error', error);
      });
    } else {
      runCloningSteps($this, workflow);
    }
  };

  const runCloningSteps = function($this, workflow) {
    const animatedLoader = cache.get('.wpstg-loading-bar-container');

    animatedLoader.css('visibility', 'visible');

    // Prepare data
    that.data = {
      action: $this.data('action'),
      accessToken: wpstg.accessToken,
      nonce: wpstg.nonce,
    };

    // Cloning data
    getCloningData();

    sendCloningAjax(workflow);
  };

  var sendCloningAjax = function(workflow) {
    const animatedLoader = cache.get('.wpstg-loading-bar-container');

    // Send ajax request
    ajax(
        that.data,
        function(response) {
        // Undefined Error
          if (false === response) {
            showError(
                'Something went wrong!<br/><br/> Go to WP Staging > Settings and lower \'File Copy Limit\' and \'DB Query Limit\'. Also set \'CPU Load Priority to low \'' +
            'and try again. If that does not help, ' +
            '<a href=\'https://wp-staging.com/support/\' target=\'_blank\'>open a support ticket</a> ',
            );
          }


          if (response.length < 1) {
            animatedLoader.css('visibility', 'hidden');
            showError(
                'Something went wrong! No response.  Go to WP Staging > Settings and lower \'File Copy Limit\' and \'DB Query Limit\'. Also set \'CPU Load Priority to low \'' +
            'and try again. If that does not help, ' +
            '<a href=\'https://wp-staging.com/support/\' target=\'_blank\'>open a support ticket</a> ',
            );
          }

          const jsonResponse = tryParseJson(response);
          if (jsonResponse !== false && jsonResponse.success === false) {
            animatedLoader.css('visibility', 'hidden');
            showErrorModal(jsonResponse);

            return;
          }

          animatedLoader.css('visibility', 'hidden');

          workflow.html(response);

          that.cloneExcludeFilters = null;
          if (that.data.action === 'wpstg_scanning') {
            that.areAllTablesChecked = true;
            that.directoryNavigator = new WpstgDirectoryNavigation('#wpstg-directories-listing', wpstg, that.notyf);
            that.tableSelector = new WpstgTableSelection('#wpstg-scanning-db', '#wpstg-workflow', '#wpstg_network_clone', '#wpstg_select_tables_cloning', wpstg);
            that.switchStep(2);
            that.cloneExcludeFilters = new WpstgExcludeFilters();
            that.directoryNavigator.countSelectedFiles();
            that.tableSelector.countSelectedTables();
          } else if (that.data.action === 'wpstg_cloning' || that.data.action === 'wpstg_update' || that.data.action === 'wpstg_reset') {
            that.switchStep(3);
          }

          // Start cloning
          that.startCloning();
        },
        'HTML',
    );
  };

  var showErrorModal = function(response) {
    const errorModal = new WpstgModal('wpstg_modal_error', wpstg);
    errorModal.show(Object.assign({
      title: 'Error',
      icon: 'error',
      html: wpstg.i18n['somethingWentWrong'] + (response.message !== undefined ? ('<br/>' + response.message) : ''),
      width: '500px',
      confirmButtonText: 'Ok',
      showCancelButton: false,
      customClass: {
        confirmButton: 'wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
        cancelButton: 'wpstg--btn--cancel wpstg-blue-primary wpstg-link-btn',
        actions: 'wpstg--modal--actions',
        popup: 'wpstg-swal-popup wpstg-centered-modal',
      },
      buttonsStyling: false,
      reverseButtons: true,
    }, response.swalOptions), {
      type: response.type,
    });
  };

  const tryParseJson = function(json) {
    // early bail if not string
    if (!json) {
      return false;
    }

    try {
      const object = JSON.parse(json);
      if (object && typeof object === 'object') {
        return object;
      }
    } catch (e) {
      // do nothing on catch
    }

    return false;
  };

  var resetClone = function(clone, excludeOptions) {
    that.data = {
      action: 'wpstg_reset',
      accessToken: wpstg.accessToken,
      nonce: wpstg.nonce,
      cloneID: clone,
    };

    that.data = {...that.data, ...excludeOptions};

    const $workFlow = cache.get('#wpstg-workflow');
    sendCloningAjax($workFlow);
  };

  /**
   * Loads Overview (first step) of Staging Job
   */
  var loadOverview = function() {
    const $workFlow = cache.get('#wpstg-workflow');
    if (dom.getActivePage() === 'wpstg_clone') {
      dom.loadingBar();
    }

    ajax(
        {
          action: 'wpstg_overview',
          accessToken: wpstg.accessToken,
          nonce: wpstg.nonce,
        },
        function(response) {
          if (response.length < 1) {
            showError(
                'Something went wrong! No response. Please try the <a href=\'https://wp-staging.com/docs/wp-staging-settings-for-small-servers/\' target=\'_blank\'>WP Staging Small Server Settings</a> or submit an error report.',
            );
          }

          const $currentStep = cache.get('.wpstg-current-step');

          $workFlow.html(response);
          if (dom.getActivePage() !== 'wpstg_backup') {
            dom.loadingPlaceholder('hidden');
          }
        },
        'HTML',
    );

    that.switchStep(1);
    cache.get('.wpstg-step3-cloning').show();
    cache.get('.wpstg-step3-pushing').hide();
  };

  /**
   * Load Tabs
   */
  const tabs = function() {
    cache.get('#wpstg-workflow').on('click', '.wpstg-tab-header', function(e) {
      e.preventDefault();

      const $this = $(this);
      const $section = cache.get($this.data('id'));

      $this.toggleClass('expand');

      $section.slideToggle();

      const tabTriangle = $this.find('.wpstg-tab-triangle');

      if ($this.hasClass('expand')) {
        tabTriangle.removeClass('wpstg-no-icon');
        tabTriangle.text('');
        tabTriangle.addClass('wpstg-rotate-90');
      } else {
        tabTriangle.removeClass('wpstg-rotate-90');
      }
    });
  };

  /**
   * Delete Clone
   * @param {String} clone
   * @param {String} deleteDir
   * @param {array} excludedTables
   */
  var deleteClone = function(clone, deleteDir, excludedTables) {
    ajax(
        {
          action: 'wpstg_delete_clone',
          clone: clone,
          accessToken: wpstg.accessToken,
          nonce: wpstg.nonce,
          excludedTables: excludedTables,
          deleteDir: deleteDir,
        },
        function(response) {
          if (response) {
            showAjaxFatalError(response);

            // Finished
            if ('undefined' !== typeof response.delete && (response.delete === 'finished' || response.delete === 'unfinished')) {
              if (response.delete === 'finished' && response.error === undefined) {
                $('.wpstg-clone[data-clone-id="' + clone + '"]').remove();
              }

              // No staging site message is also of type/class .wpstg-class but hidden
              // We have just excluded that from search when counting no of clones
              if ($('#wpstg-existing-clones .wpstg-clone').length < 1) {
                cache.get('#wpstg-existing-clones').find('h3').text('');
                cache.get('#wpstg-no-staging-site-results').show();
              }

              cache.get('.wpstg-loader').hide();
              dom.loadingPlaceholder('hidden');
              // finish modal popup
              if (wpstg.i18n.wpstg_delete_clone !== null && response.delete === 'finished') {
                const params = {
                  'status': 'finished',
                };
                that.wpstgProcessModal.openProcessModal({'action': 'wpstg_delete_clone', 'cloneID': clone}, params, false, false);
                WPStagingCommon.getSwalModal(true, {
                  confirmButton: 'wpstg--btn--confirm wpstg-green-button wpstg-button wpstg-link-btn wpstg-100-width',
                }).fire({
                  'icon': 'success',
                  'html': '<div style="display:block"><h2 style="color: #565656;">' + wpstg.i18n.wpstg_delete_clone.title + '</h2></div>',
                  'confirmButtonText': 'Close',
                  'showCancelButton': false,
                  'showConfirmButton': true,
                }).then(function(result) {
                  if (result.value) {
                    WPStagingCommon.closeSwalModal();
                    dom.loadingPlaceholder('hidden');
                  }
                },
                );
              }
              return;
            }
          }
          // continue
          if (true !== response) {
            deleteClone(clone, deleteDir, excludedTables);
            return;
          }
        },
    );
  };

  /**
   * Cancel Cloning Process
   */
  var cancelCloning = function() {
    that.timer('stop');


    if (true === that.isFinished) {
      return true;
    }

    ajax(
        {
          action: 'wpstg_cancel_clone',
          clone: that.data.cloneID,
          accessToken: wpstg.accessToken,
          nonce: wpstg.nonce,
        },
        function(response) {
          if (response && 'undefined' !== typeof (response.delete) && response.delete === 'finished') {
            cache.get('.wpstg-loader').hide();
            // Load overview
            loadOverview();
            return;
          }

          if (true !== response) {
          // continue
            cancelCloning();
            return;
          }

          // Load overview
          loadOverview();
        },
    );
  };

  /**
   * Cancel Cloning Process
   */
  var cancelCloningUpdate = function() {
    if (true === that.isFinished) {
      return true;
    }

    ajax(
        {
          action: 'wpstg_cancel_update',
          clone: that.data.cloneID,
          accessToken: wpstg.accessToken,
          nonce: wpstg.nonce,
        },
        function(response) {
          if (response && 'undefined' !== typeof (response.delete) && response.delete === 'finished') {
          // Load overview
            loadOverview();
            return;
          }

          if (true !== response) {
          // continue
            cancelCloningUpdate();
            return;
          }

          // Load overview
          loadOverview();
        },
    );
  };

  /**
   * Cancel Cloning Process
   */
  var restart = function() {
    if (true === that.isFinished) {
      return true;
    }

    ajax(
        {
          action: 'wpstg_restart',
          // clone: that.data.cloneID,
          accessToken: wpstg.accessToken,
          nonce: wpstg.nonce,
        },
        function(response) {
          if (response && 'undefined' !== typeof (response.delete) && response.delete === 'finished') {
          // Load overview
            loadOverview();
            return;
          }

          if (true !== response) {
          // continue
            cancelCloningUpdate();
            return;
          }

          // Load overview
          loadOverview();
        },
    );
  };

  /**
   * Append the log to the logging window
   * @param string log
   * @return void
   */
  const getLogs = function(log) {
    if (that.processModalType === null) {
      that.processModalType = that.wpstgProcessModal.getModalType();
    }

    const $container = $(WPStagingCommon.getSwalContainer());
    if (Array.isArray(log)) {
      log.forEach((logMessage) => {
        if (logMessage !== null) {
          if (!that.messages.find(({message}) => message === logMessage.message)) {
            that.messages.push(logMessage);
            if ($container === null) {
              return;
            }

            const $logsContainer = $container.find('.wpstg-' + that.processModalType + '-process-logs');
            const msgClass = `wpstg--modal--process--msg--${logMessage.type.toLowerCase() || 'info'}`;
            $logsContainer.append(`<p class="${msgClass}">[${logMessage.type || 'info'}] - [${logMessage.date}] - ${logMessage.message}</p>`);
          }
        }
      });
    } else {
      if (!that.messages.find(({message}) => message === log.message)) {
        that.messages.push(log);
        if ($container === null) {
          return;
        }

        const $logsContainer = $container.find('.wpstg-' + that.processModalType + '-process-logs');
        const msgClass = `wpstg--modal--process--msg--${log.type.toLowerCase() || 'info'}`;
        $logsContainer.append(`<p class="${msgClass}">[${log.type || 'info'}] - [${log.date}] - ${log.message}</p>`);
      }
    }
    document.querySelectorAll('.wpstg-' + that.processModalType + '-process-logs').forEach((element) => {
      element.scrollTop = element.scrollHeight;
    });
  };


  /**
   * Check disk space
   * @return string json
   */
  var checkDiskSpace = function() {
    cache.get('#wpstg-check-space').on('click', function(e) {
      cache.get('.wpstg-loader').show();
      dom.loadingBar();
      const excludedDirectories = encodeURIComponent(that.directoryNavigator.getExcludedDirectories());
      const extraDirectories = encodeURIComponent(that.directoryNavigator.getExtraDirectoriesRootOnly());
      const isUploadsSymlinked = document.getElementById('wpstg_symlink_upload').checked;

      ajax(
          {
            action: 'wpstg_check_disk_space',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            excludedDirectories: excludedDirectories,
            extraDirectories: extraDirectories,
            isUploadsSymlinked: isUploadsSymlinked,
          },
          function(response) {
            cache.get('.wpstg-loader').hide();
            dom.loadingBar('hidden');
            if (false === response) {
              cache.get('#wpstg-clone-id-error').text('Can not detect required disk space').show();
              return;
            }

            // Show required disk space
            cache.get('#wpstg-clone-id-error').html(
                '<strong>Estimated necessary disk space: ' + response.requiredSpace + '</strong>' +
              (response.errorMessage !== null ? ('<br>' + response.errorMessage) : '') +
              '<br><span style="color:#444;">Before proceeding, make sure that your server has enough free disk space to clone the website. You can check the available disk space in your hosting customer account (e.g. cPanel).</span>').show();
          },
          'json',
          false,
      );
    });
  };

  /**
   * Show or hide animated loading icon
   * @param bool isLoading
   */
  const isLoading = function(isLoading) {
    if (!isLoading || isLoading === false) {
      cache.get('.wpstg-loader').hide();
    } else {
      cache.get('.wpstg-loader').show();
    }
  };

  /**
   * Count up processing execution time
   * @param string status
   * @return html
   */
  that.timer = function(status) {
    if (status === 'stop') {
      const time = that.time;
      that.time = 1;
      clearInterval(that.executionTime);
      return that.convertSeconds(time);
    }


    that.executionTime = setInterval(function() {
      if (null !== document.getElementById('wpstg-processing-timer')) {
        document.getElementById('wpstg-processing-timer').innerHTML = 'Elapsed Time: ' + that.convertSeconds(that.time);
      }
      that.time++;
      if (status === 'stop') {
        that.time = 1;
        clearInterval(that.executionTime);
      }
    }, 1000);
  };

  /**
   * Convert seconds to hourly format
   * @param int seconds
   * @return string
   */
  that.convertSeconds = function(seconds) {
    const date = new Date(null);
    date.setSeconds(seconds); // specify value for SECONDS here
    return date.toISOString().substr(11, 8);
  };

  /**
   * Start Cloning Process
   * @type {Function}
   */
  that.startCloning = (function() {
    resetErrors();

    // Register function for checking disk space
    checkDiskSpace();

    if ('wpstg_cloning' !== that.data.action && 'wpstg_update' !== that.data.action && 'wpstg_reset' !== that.data.action) {
      return;
    }

    that.isCancelled = false;

    // Start the process
    start();

    // Functions
    // Start
    function start() {
      cache.get('.wpstg-loader').show();
      cache.get('#wpstg-cancel-cloning').text('Cancel');
      cache.get('#wpstg-resume-cloning').hide();
      cache.get('#wpstg-error-details').hide();


      // Clone Database
      setTimeout(function() {
        // cloneDatabase();
        window.addEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
        processing();
      }, wpstg.delayReq);
    }


    /**
     * Start ajax processing
     * @return string
     */
    var processing = function() {
      if (true === that.isCancelled) {
        window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
        return false;
      }

      isLoading(true);

      let excludedDirectories = '';
      let extraDirectories = '';
      if (that.directoryNavigator !== null) {
        excludedDirectories = that.directoryNavigator.getExcludedDirectories();
        extraDirectories = that.directoryNavigator.getExtraDirectoriesRootOnly();
      }

      // Show logging window

      WPStaging.requestType = 'wpstg_cloning';

      WPStaging.ajax(
          {
            action: 'wpstg_processing',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            excludedTables: getExcludedTables(),
            excludedDirectories: encodeURIComponent(excludedDirectories),
            extraDirectories: encodeURIComponent(extraDirectories),
          },
          function(response) {
            showAjaxFatalError(response);

            // Add Log messages
            if ('undefined' !== typeof (response.last_msg) && response.last_msg) {
              getLogs(response.last_msg);
            }
            // Continue processing
            if (false === response.status) {
              progressBar(response);

              setTimeout(function() {
                processing();
              }, wpstg.delayReq);
            } else if (true === response.status && 'finished' !== response.status) {
              cache.get('#wpstg-error-details').hide();
              cache.get('#wpstg-error-wrapper').hide();
              progressBar(response, true);
              processing();
            } else if ('finished' === response.status || ('undefined' !== typeof (response.job_done) && response.job_done)) {
              window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
              WPStaging.requestType = '';
              finish(response);
            }
          },
          'json',
          false,
      );
    };

    // Finish
    function finish(response) {
      if (true === that.getLogs) {
        getLogs();
      }

      progressBar(response);

      // Add Log
      if ('undefined' !== typeof (response.last_msg)) {
        getLogs(response.last_msg);
      }
      if (wpstg.i18n[that.data.action] !== null) {
        that.wpstgProcessModal.openSuccessModal(wpstg.i18n[that.data.action], true, response.url);
      }
    }

    /**
     * Add percentage progress bar
     * @param object response
     * @return {Boolean}
     */
    var progressBar = function(response, restart) {
      if (response !== null) {
        that.wpstgProcessModal.openProcessModal(that.data, response, true);
      }
    };
  });

  /**
   * @return {Promise<boolean>}
   */
  const isCloneDestinationPathSameAsRoot = function() {
    return new Promise(function(resolve) {
      const rootPath = dom.qs('#wpstg-use-target-dir')?.dataset.basePath || '';
      const destinationPath = dom.qs('#wpstg_clone_dir')?.value || '';

      if (rootPath !== destinationPath) {
        resolve(false);
      } else {
        dom.qs('#wpstg_clone_dir').style.borderColor = 'red';
        dom.notify('error', 'The target path must be different from the root path of the production website.');
        resolve(true);
      }
    });
  };

  that.switchStep = function(step) {
    cache.get('.wpstg-current-step')
        .removeClass('wpstg-current-step');
    cache.get('.wpstg-step' + step)
        .addClass('wpstg-current-step');
  };

  that.checkUserDbPermissions = function checkUserDbPermissions(operationType) {
    return new Promise(function(resolve) {
      WPStaging.ajax({
        action: 'wpstg_check_user_permissions',
        accessToken: wpstg.accessToken,
        nonce: wpstg.nonce,
        type: operationType,
      }, function(response) {
        if (response.success) {
          resolve(true);
        } else {
          WPStagingCommon.getSwalModal(true, {
            container: 'wpstg-swal-push-container',
          }).fire({
            title: '',
            icon: 'warning',
            html: response.data.message,
            width: '750px',
            focusConfirm: false,
            confirmButtonText: 'Proceed',
            showCancelButton: true,
          }).then(function(result) {
            if (result.isConfirmed) {
              resolve(true);
            }
          });

          $('#wpstg-db-permission-show-full-message').click(function() {
            $('#wpstg-permission-info-output').html($('#wpstg-permission-info-data').html());
          });
        }
      }, 'json', false);
    });
  };

  /**
   * Initiation
   * @type {Function}
   */
  that.init = (function() {
    loadOverview();
    elements();
    stepButtons();
    tabs();
    WPStagingCommon.listenTooltip();
    new WpstgMainMenu();
    new WpstgCloneStaging();
    new WpstgCloningAdvanceSettings();
    new WpstgProcessModal();
    new WpstgSidebarMenu();
    that.notyf = new Notyf({
      duration: 10000,
      position: {
        x: 'center',
        y: 'bottom',
      },
      dismissible: true,
      types: [
        {
          type: 'warning',
          background: 'orange',
          icon: false,
        },
      ],
    });
  });
  /**
   * Ajax call
   * @type {ajax}
   */
  that.ajax = ajax;
  that.showError = showError;
  that.getLogs = getLogs;
  that.loadOverview = loadOverview;

  return that;
})(jQuery);

jQuery(document).ready(function() {
  WPStaging.init();
  // This is necessary to make WPStaging var accessible in WP Staging PRO js script
  window.WPStaging = WPStaging;
});

/**
 * Report Issue modal
 */
jQuery(document).ready(function($) {
  $('body').on('click', '.wpstg-report-issue-button', function(e) {
    const contactUsModal = document.querySelector('#wpstg-contact-us-modal');
    if (contactUsModal != null && typeof contactUsModal !== 'undefined') {
      dom.show('#wpstg-contact-us-modal');
      new WpstgContactUs();
    }
    $('.wpstg-report-issue-form').toggleClass('wpstg-report-show');
    e.preventDefault();
  });

  $('body').on('click', '.wpstg-backups-report-issue-button', function(e) {
    $('.wpstg-report-issue-form').toggleClass('wpstg-report-show');
    e.preventDefault();
  });

  $('body').on('click', '#wpstg-report-cancel', function(e) {
    $('.wpstg-report-issue-form').removeClass('wpstg-report-show');
    e.preventDefault();
  });

  $('body').on('click', '#wpstg-report-submit', function(e) {
    const self = $(this);
    sendIssueReport(self, 'false');
    e.preventDefault();
  });

  /*
   * Close Success Modal
   */
  $('body').on('click', '#wpstg-success-button', function(e) {
    e.preventDefault();
    $('.wpstg-report-issue-form').removeClass('wpstg-report-show');
  });

  function sendIssueReport(button, forceSend = 'false') {
    const spinner = button.next();
    const email = $('.wpstg--tab--header .wpstg-report-email').val();
    const hosting_provider = $('.wpstg--tab--header .wpstg-report-hosting-provider').val();
    const message = $('.wpstg--tab--header .wpstg-report-description').val();
    const syslog = $('.wpstg--tab--header .wpstg-report-syslog').is(':checked');
    const terms = $('.wpstg--tab--header .wpstg-report-terms').is(':checked');

    button.attr('disabled', true);
    spinner.css('visibility', 'visible');

    $.ajax({
      url: ajaxurl,
      type: 'POST',
      dataType: 'json',
      async: true,
      data: {
        'action': 'wpstg_send_report',
        'accessToken': wpstg.accessToken,
        'nonce': wpstg.nonce,
        'wpstg_email': email,
        'wpstg_provider': hosting_provider,
        'wpstg_message': message,
        'wpstg_syslog': +syslog,
        'wpstg_terms': +terms,
        'wpstg_force_send': forceSend,
      },
    }).done(function(data) {
      button.attr('disabled', false);
      spinner.css('visibility', 'hidden');

      if (data.errors.length > 0) {
        $('.wpstg-report-issue-form .wpstg-message').remove();

        let errorMessage = $('<div />').addClass('wpstg-message wpstg-error-message');
        $.each(data.errors, function(key, value) {
          if (value.status === 'already_submitted') {
            errorMessage = '';
            // TODO: remove default custom classes
            WPStagingCommon.getSwalModal(true, {
              container: 'wpstg-issue-resubmit-confirmation',
            }).fire({
              title: '',
              icon: 'warning',
              html: value.message,
              showCancelButton: true,
              focusConfirm: false,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.isConfirmed) {
                sendIssueReport(button, 'true');
              }
            });
          } else {
            errorMessage.append('<p>' + value + '</p>');
          }
        });

        $('.wpstg-report-issue-form').prepend(errorMessage);
      } else {
        const successMessage = $('<div />').addClass('wpstg-message wpstg-success-message');
        successMessage.append('<p>Thanks for submitting your request! You should receive an auto reply mail with your ticket ID immediately for confirmation!<br><br>If you do not get that mail please contact us directly at <strong>support@wp-staging.com</strong></p>');

        $('.wpstg--tab--header .wpstg-report-issue-form').html(successMessage);
        if (document.getElementById('wpstg-modal-close') === null || document.getElementById('wpstg-modal-close') === undefined) {
          $('.wpstg--tab--header .wpstg-success-message').append('<div class="wpstg-mt-10px wpstg-float-right"><a id="wpstg-success-button" href="#" class="wpstg--red"><span class="wpstg-ml-8px">Close</span></a></div>');
        }

        // Hide message
        setTimeout(function() {
          $('.wpstg--tab--header .wpstg-report-issue-form').removeClass('wpstg-report-active');
        }, 2000);
      }
    });
  }

  // Open/close actions drop down menu
  $(document).on('click', '.wpstg-dropdown>.wpstg-dropdown-toggler', function(e) {
    e.preventDefault();
    $(e.target).next('.wpstg-dropdown-menu').toggleClass('shown');

    $(e.target).find('.wpstg-caret').toggleClass('wpstg-caret-up');
  });

  $(document).on('click', '.wpstg-caret', function(e) {
    e.preventDefault();

    const toggler = $(e.target).closest('.wpstg-dropdown-toggler');

    if (toggler) {
      toggler.trigger('click');
    }
  });

  // Close action drop down menu if clicked anywhere outside
  document.addEventListener('click', function(event) {
    const isClickInside = event.target.closest('.wpstg-dropdown-toggler');
    if (!isClickInside) {
      const dropDown = document.getElementsByClassName('wpstg-dropdown-menu');
      for (let i = 0; i < dropDown.length; i++) {
        dropDown[i].classList.remove('shown');
      }
      $('.wpstg-caret').removeClass('wpstg-caret-up');
    }
  });

  // "Event info" for backup errors
  window.addEventListener('finishedProcessWithError', function(customEvent) {
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      dataType: 'json',
      data: {
        'action': 'wpstg_job_error',
        'accessToken': wpstg.accessToken,
        'nonce': wpstg.nonce,
        'error_message': customEvent.detail.error,
        'job_id': WPStagingCommon.getJobId(),
      },
    });
  });

  document.addEventListener('click', function(event) {
    if (event.target.id !== 'wpstg-login-link') {
      return;
    }

    event.preventDefault();
    window.open('/wp-login.php', '_blank');
    if (window.WPStaging && window.WPStaging.wpstgProcessModal) {
      window.WPStaging.wpstgProcessModal.stop();
      window.WPStaging.loadOverview();
    }
  });
});
